import type { FaireProductEntity } from "../../entity_types/product";

export const p_w2av62z6uw: FaireProductEntity = {
  token: "p_w2av62z6uw",
  type: "product",
  name: "IT'S BUTTER JUST RIGHT 24 PCS - 2- 12 PC PDQ",
  brandToken: "b_6stq13nzkh",
  brandName: "Electrum Group Holdings LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/27ef0912aa1eff849d34b388de32c3c79a4ce3bce7da60275c09c62991b354dc.png",
  galleryImageUrls: [],
  priceDollars: 3.49,
  description:
    "It's Butter™ Squishy brings the novelty tun to the toy aisle with a soft, slow-rise squish that's impossible to put down. Styled like a real stick of butter but made tor play, its tunny. satisfying, and totally trend-ready. A perfect sensory toy for kids and teens ages 6-16.",
  tags: [],
  msrpDollars: 6.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:47.029Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
